import { render, staticRenderFns } from "./tranferWallet.vue?vue&type=template&id=9b80d8da&"
import script from "./tranferWallet.vue?vue&type=script&lang=js&"
export * from "./tranferWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports